<template>
	<div id="app">
		<BottomBar ref='BottomBarView'/>
		<router-view 

		ref="archView"
		/>
	</div>
</template>
<script>
import BottomBar from '@/components/BottomBar.vue'

export default {
	name: "app",
	components:{
		BottomBar
	},
	methods:{

	},
	computed:{

	},
	mounted(){

	}
}
</script>
<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::-webkit-scrollbar {
    display:none;
  }

  body {
    margin: 0;
    padding: 0;
    background-color:rgb(240, 239, 239);
  }

  .main-content {
      min-height: calc(100vh - 56px);
      margin-bottom: 56px;
  }

  .navless-content {
      min-height: 100vh;
  }

  .listOfMission {
      min-height: 100vh;
      padding-bottom:56px;
  }

  .main-content-90 {
    min-height: calc(90vh - 56px);
    margin-bottom: 56px;
  }

  .navless-content-80 {
      min-height: 80vh;
  }

  .top-bottom-margin {
      padding-top: 16px;
      padding-bottom: 16px;
  }

  @media screen and (max-width: 900px) {
      .main-content {
          min-height: calc(90vh - 56px);
          margin-bottom: 56px;
      }

      .navless-content {
          min-height: 90vh;
      }

      .listOfMission {
          min-height: 90vh;
          padding-bottom:56px;
      }
  }

  .smooth{
    transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
  }


  .hide {
      display: none !important;
  }

  .actionForm {
      padding-top:8px;
      max-width: 300px;
      margin: auto;
  }

  .missionForm {
      padding-top:16px;
      max-width: 500px;
      margin: auto;
  }
  
  .loader-spinner {
      width: 3rem !important;
      height: 3rem !important;
  }

  .offlineIcon {
      width: 6rem;
      height: 6rem;
  }

  .top-margin-align {
      margin-top: 56px;
  }

  .unSelectable {
    -webkit-user-select: none;  /* Chrome all / Safari all */
    -moz-user-select: none;     /* Firefox all */
    -ms-user-select: none;      /* IE 10+ */
    user-select: none;          /* Likely future */   
  }
</style>
